import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Colors } from 'chart.js';
import { DatePipe } from '@angular/common';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { FormArray } from '@angular/forms';

@Component({
  selector: 'app-kalaignar100-report',
  templateUrl: './kalaignar100-report.component.html',
  styleUrls: ['./kalaignar100-report.component.scss'],
})
export class Kalaignar100ReportComponent implements OnInit {
  winners: any[] = [];
  selectedImages: File[] = [];
  serialNumber: number = 1;
  winnerform: FormGroup;
  dtOptions: DataTables.Settings = {};
  hidden: boolean = true;
  district: string;
  constituency: string = '';
  message: boolean;
  spinner: boolean;
  districtname: any;
  tableshow: boolean;
  isButtonDisabled: boolean = false;
  loginuser: any;
  catagory: any = this.ApiService.catagory;
  imageField: boolean = false;
  // photo1File: File;
  submitted = false;
  //formData = new FormData();
  constructor(
    public ApiService: ApiServiceService,
    private fb: FormBuilder,
    private spinnerService: NgxSpinnerService,
    public datepipe: DatePipe,
    private sanitizer: DomSanitizer,
    private router: Router
  ) {
    this.district = JSON.parse(localStorage.getItem('user_district'));
  }
  district_list: any[] = this.ApiService.all_districts;
  constituency_list: any = this.ApiService.all_constituency;
  user_constituency: any;
  winnerImages: string[] = [];
  isButtonVisible: boolean = true;
  show_constituency: string;
  show_district: string;
  show_no_of_participants: any;
  show_comp_date: any;
  show_venue: any;
  imageSrc1: any;
  imageSrc2: any;
  imageSrc3: any;
  imageSrc4: any;
  imageSrc5: any;
  show_data:boolean=true;
  user_category:any

  winnersArray: any[] = [];
  ngOnInit(): void {
    // this.addRow();
    this.FormInitialize();
    this.districtname = JSON.parse(localStorage.getItem('user_district'));
    let obj = this.constituency_list;
    this.user_constituency = obj[this.districtname];
    this.showSpinner();
    console.log(this.districtname);
    this.loginuser = JSON.parse(localStorage.getItem('login_user_details'));
    console.log(this.loginuser);
    // this.winner_report_api(this.districtname)
    console.log(this.loginuser.category);
  this.user_category  =this.loginuser.category
    this.spinner = false;
    this.dtOptions[0] = {
      pagingType: 'full_numbers',
      order: [],
    };
    // this.FormInitialize();
    // this.addRow();
  }
  sanitizeWinnerImage(winner: any): SafeUrl {
    const objectURL = 'data:image/jpeg;base64,' + winner;
    return this.sanitizer.bypassSecurityTrustUrl(objectURL);
  }
  winner_report_api(constituency: any)
  {
    this.FormInitialize();
    this.spinner = true;
    // this.show_data=true;
    
    this.ApiService.district_check_winner_list_show(constituency).subscribe(
      (data) => {
        console.log(data);
        
        // this.spinner = false;
        this.spinner = true;
        const competitionDetails = data['competition_details'];
        if (competitionDetails.length > 0) 
        {

        
          // Assuming you want to access the first competition detail
          const firstCompetitionDetail = competitionDetails[0];

          // Accessing properties of the first competition detail
          // this.show_district = firstCompetitionDetail.district;
          // this.show_constituency = firstCompetitionDetail.constituency;
          this.show_no_of_participants =
            firstCompetitionDetail.no_of_participants;
          this.show_comp_date = firstCompetitionDetail.comp_date;
          this.show_venue = firstCompetitionDetail.venue;
          const images = data['images'];
          this.winnersArray = data['winner_list'];
          console.log(images[1]);
          let objectURL1 = 'data:image/jpeg;base64,' + images[1].image;
          this.imageSrc1 = this.sanitizer.bypassSecurityTrustUrl(objectURL1);

          let objectURL2 = 'data:image/jpeg;base64,' + images[2].image;
          this.imageSrc2 = this.sanitizer.bypassSecurityTrustUrl(objectURL2);

          let objectURL3 = 'data:image/jpeg;base64,' + images[3].image;
          this.imageSrc3 = this.sanitizer.bypassSecurityTrustUrl(objectURL3);
          let objectURL4 = 'data:image/jpeg;base64,' + images[4].image;
          this.imageSrc4 = this.sanitizer.bypassSecurityTrustUrl(objectURL4);
          let objectURL5 = 'data:image/jpeg;base64,' + images[5].image;
          this.imageSrc5 = this.sanitizer.bypassSecurityTrustUrl(objectURL5);
          this.spinner = false;
          this.show_data=false;
        } else {
          this.spinner = false;
          this.show_data=true;
          console.log('No competition details found.');
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }
 
  printPage() {
    window.print();
  }
  FormInitialize() {
    this.show_district = '';
    this.show_constituency = '';
    this.show_no_of_participants = '';
    this.show_comp_date = '';
    this.show_venue = '';
    const images = '';
    this.winnersArray = [];
    this.imageSrc1 = '';
    this.imageSrc2 = '';
    this.imageSrc3 = '';
    this.imageSrc4 = '';
    this.imageSrc5 = '';
  }

  public showSpinner(): void {
    this.spinnerService.show();
  }

  reload() {
    window.location.reload();
  }
  Constituency_selection(selection: any) 
  {
    this.FormInitialize();
    this.constituency='';
   this.show_data=true;
    console.log(selection)
    if (selection != 'null') 
    {
      //console.log(this.district);
      let obj = this.ApiService.all_constituency;
       this.user_constituency = obj[this.district];
       //console.log(this.user_constituency)
    }
    

  }
}
